import { render, staticRenderFns } from "./unrelevance1.vue?vue&type=template&id=56424155&scoped=true"
import script from "./unrelevance1.vue?vue&type=script&lang=js"
export * from "./unrelevance1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56424155",
  null
  
)

export default component.exports